import { QualificationInterface } from "../../../../common/interfaces/QualificationInterface";
import { setIsModalOpen } from "../../QualificationDetailSlice";
import { ChevronLeft } from "../../../../common/svg/ChevronLeft";
import { JSX, useCallback, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useNavigate } from "react-router";
import { RouteEnum } from "../../../../common/enums/RouteEnum";

interface EmployeeHeaderTagProps {
    qualificationData?: QualificationInterface;
}

export const EmployeeHeaderTag = (
    props: EmployeeHeaderTagProps,
): JSX.Element | null => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { qualificationData } = props;
    const modalRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const { isModalOpen } = useAppSelector(
        (state) => state.qualificationDetail,
    );

    const handleClickOutside = useCallback(
        (event: MouseEvent): void => {
            if (
                modalRef.current &&
                !modalRef.current.contains(event.target as Node) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target as Node)
            ) {
                dispatch(setIsModalOpen(false));
            }
        },
        [dispatch],
    );

    useEffect(() => {
        if (isModalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isModalOpen, handleClickOutside]);

    if (
        !qualificationData?.qualification_exemptions ||
        qualificationData.qualification_exemptions.length === 0
    ) {
        return null;
    }

    return (
        <div className={"p-qualification-detail__header__content__exemptions"}>
            <p>
                Vrijgesteld door behalen certificaat{" "}
                <button
                    type="button"
                    className={
                        "p-qualification-detail__header__content__exemptions__link"
                    }
                    onClick={() =>
                        navigate(
                            RouteEnum.QUALIFICATIONS +
                                "/" +
                                qualificationData?.qualification_exemptions[0]
                                    ?.exempted_qualification?.id,
                        )
                    }
                >
                    {
                        qualificationData?.qualification_exemptions[0]
                            ?.exempted_qualification?.name
                    }
                </button>
            </p>
            {qualificationData?.qualification_exemptions?.length > 1 && (
                <div
                    className={
                        "p-qualification-detail__header__content__exemptions__tag"
                    }
                >
                    <button
                        type="button"
                        className={`p-qualification-detail__header__content__exemptions__tag__content ${isModalOpen ? "p-qualification-detail__header__content__exemptions__tag__content--active" : ""}`}
                        onClick={() => dispatch(setIsModalOpen(!isModalOpen))}
                        ref={buttonRef}
                    >
                        +
                        {qualificationData?.qualification_exemptions.length - 1}{" "}
                        <ChevronLeft />
                    </button>
                    {isModalOpen && (
                        <span
                            className={
                                "p-qualification-detail__header__content__exemptions__tag__modal"
                            }
                            ref={modalRef}
                        >
                            {qualificationData?.qualification_exemptions
                                .slice(1)
                                .map((exemption) => (
                                    <button
                                        type="button"
                                        key={exemption.id}
                                        onClick={() =>
                                            navigate(
                                                RouteEnum.QUALIFICATIONS +
                                                    "/" +
                                                    exemption
                                                        .exempted_qualification
                                                        .id,
                                            )
                                        }
                                    >
                                        {exemption.exempted_qualification.name}
                                    </button>
                                ))}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};
